import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Toaster from 'src/Toaster/Toaster';
import { Box, Typography, Grid, FormControlLabel, Button } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { IOtherBusinessLicense } from 'src/Types/module/member/CompanyInformation';
import { HttpClient } from 'src/Helpers/http/http';
import { IResponse } from 'src/Types/module/common/commonTypes';
import MultipleAndSingleImgValidateWithPreview from 'src/common/FileValidation/MultipleAndSingleImgValidateWithPreview';

interface IProps {
  otherBusiness: IOtherBusinessLicense;
  memberId: string;
  setRefresh: (value: boolean) => void;
  setOpen: (value: boolean) => void;
  refresh: boolean;
}

const CompanyBusinessLicense = ({
  otherBusiness,
  memberId,
  setRefresh,
  setOpen,
  refresh,
}: IProps) => {
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm();
  const [businessLicense, setBusinessLicense] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  console.log(businessLicense);
  const onSubmit = async () => {
    const inputsData: any = { ...businessLicense };
    const formData = new FormData();

    if (businessLicense && Object?.values(businessLicense)?.length > 0) {
      Object?.keys(inputsData)?.forEach((key) => {
        if (typeof inputsData[key] === 'object') {
          if (inputsData[key][0] && inputsData[key]) {
            formData.append(key, inputsData[key][0]);
          }
        } else {
          formData.append(key, inputsData[key]);
        }
      });
      try {
        const data: IResponse = await HttpClient.patch(
          `/api/atab/admin/member-company/member/business-other-license/${memberId}`,
          formData
        );

        if (data.success) {
          Toaster().fire({
            icon: 'success',
            title: data.message,
          });
          setRefresh(!refresh);
          setOpen(false);
          setIsLoading(false);
        }
      } catch (err: any) {
        Toaster().fire({
          icon: 'error',
          title: err?.response?.data.message,
        });
        setIsLoading(false);
      }
    } else {
      Toaster().fire({
        icon: 'error',
        title: 'Please change field first',
      });
    }
  };
  return (
    <Box component='form' onSubmit={handleSubmit(onSubmit)} p={2}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant='h6' gutterBottom>
            Update Other business license
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      otherBusiness?.companyBusinessLicense?.hajj_license
                        ? true
                        : false
                    }
                  />
                }
                label='Hajj'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,

                      hajj_license: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      hajj_license: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      otherBusiness?.companyBusinessLicense?.umrah_license
                        ? true
                        : false
                    }
                  />
                }
                label='Umrah'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      umrah_license: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      umrah_license: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      otherBusiness?.companyBusinessLicense?.recruting_license
                        ? true
                        : false
                    }
                  />
                }
                label='Recruiting'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      recruting_license: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      recruting_license: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      otherBusiness?.companyAssociationMembership
                        ?.baira_membership
                        ? true
                        : false
                    }
                  />
                }
                label='BAIRA'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      baira_membership: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      baira_membership: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={
                        otherBusiness?.companyAssociationMembership
                          ?.haab_membership
                          ? true
                          : false
                      }
                    />
                  }
                  label='HAAB'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setBusinessLicense({
                        ...businessLicense,
                        haab_membership: 1,
                      });
                    } else {
                      setBusinessLicense({
                        ...businessLicense,
                        haab_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={
                        otherBusiness?.companyAssociationMembership
                          ?.iata_membership
                          ? true
                          : false
                      }
                    />
                  }
                  label='IATA'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setBusinessLicense({
                        ...businessLicense,
                        iata_membership: 1,
                      });
                    } else {
                      setBusinessLicense({
                        ...businessLicense,
                        iata_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={
                        otherBusiness?.companyAssociationMembership
                          ?.toab_membership
                          ? true
                          : false
                      }
                    />
                  }
                  label='TOAB'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setBusinessLicense({
                        ...businessLicense,
                        toab_membership: 1,
                      });
                    } else {
                      setBusinessLicense({
                        ...businessLicense,
                        toab_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ pl: { xs: 12, md: 0 } }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={
                        otherBusiness?.companyAssociationMembership
                          ?.tdab_membership
                          ? true
                          : false
                      }
                    />
                  }
                  label='TDAB'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setBusinessLicense({
                        ...businessLicense,
                        tdab_membership: 1,
                      });
                    } else {
                      setBusinessLicense({
                        ...businessLicense,
                        tdab_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>

            {/* Add more items here as needed */}
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant='h6' gutterBottom>
            Update Involved in tourism activities
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: 15,
              pl: { xs: 7, md: 0 },
              // justifyContent: 'space-evenly',
              textAlign: 'center',
              alignItems: 'center',
            }}
          >
            <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      otherBusiness?.companyBusinessLicense?.inbound
                        ? true
                        : false
                    }
                  />
                }
                label=' Inbound'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      inbound: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      inbound: 0,
                    });
                  }
                }}
              />
            </Box>
            <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      otherBusiness?.companyBusinessLicense?.outbound
                        ? true
                        : false
                    }
                  />
                }
                label='Outbound'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      outbound: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      outbound: 0,
                    });
                  }
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      {/*---------------------- file------------------------ */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {/* Hajj License */}
        {(otherBusiness?.companyBusinessLicense?.hajj_license === 1 ||
          businessLicense?.hajj_license === 1) && (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Member organization Hajj license ( max size 5mb )'
                fieldName='hajj_license_file'
                imgSerUrl={[
                  otherBusiness?.companyBusinessLicense?.hajj_license_file,
                ]}
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    hajj_license_file: e,
                  }))
                }
                mode='single'
              />
            </Box>
          </Grid>
        )}

        {/* Umrah License */}
        {(otherBusiness?.companyBusinessLicense?.umrah_license === 1 ||
          businessLicense?.umrah_license === 1) && (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                hideCustomLabel
                label='Member organization Umrah license ( max size 5mb )'
                fieldName='umrah_license_file'
                imgSerUrl={[
                  otherBusiness?.companyBusinessLicense?.umrah_license_file,
                ]}
                mode='single'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    umrah_license_file: e,
                  }))
                }
              />
            </Box>
          </Grid>
        )}

        {/* Recruiting License */}
        {(otherBusiness?.companyBusinessLicense?.recruting_license === 1 ||
          businessLicense?.recruting_license === 1) && (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Member organization Recruiting license ( max size 5mb )'
                fieldName='recruting_license_file'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    recruting_license_file: e,
                  }))
                }
                mode='single'
                imgSerUrl={[
                  otherBusiness?.companyBusinessLicense?.recruting_license_file,
                ]}
              />
            </Box>
          </Grid>
        )}

        {/* BAIRA Membership */}
        {(otherBusiness?.companyAssociationMembership?.baira_membership === 1 ||
          businessLicense?.baira_membership === 1) && (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload association BAIRA document ( max size 5mb )'
                fieldName='baira_membership_file'
                imgSerUrl={[
                  otherBusiness?.companyAssociationMembership
                    ?.baira_membership_file,
                ]}
                mode='single'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    baira_membership_file: e,
                  }))
                }
              />
            </Box>
          </Grid>
        )}

        {/* HAAB Membership */}
        {(otherBusiness?.companyAssociationMembership?.haab_membership === 1 ||
          businessLicense?.haab_membership === 1) && (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload association HAAB document ( max size 5mb )'
                fieldName='haab_membership_file'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    haab_membership_file: e,
                  }))
                }
                hideCustomLabel
                mode='single'
                imgSerUrl={[
                  otherBusiness?.companyAssociationMembership
                    ?.haab_membership_file,
                ]}
              />
            </Box>
          </Grid>
        )}

        {/* IATA Membership */}
        {(otherBusiness?.companyAssociationMembership?.iata_membership === 1 ||
          businessLicense?.iata_membership === 1) && (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload association IATA document ( max size 5mb )'
                fieldName='iata_membership_file'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    iata_membership_file: e,
                  }))
                }
                mode='single'
                imgSerUrl={[
                  otherBusiness?.companyAssociationMembership
                    ?.iata_membership_file,
                ]}
              />
            </Box>
          </Grid>
        )}

        {/* TOAB Membership */}
        {(otherBusiness?.companyAssociationMembership?.toab_membership === 1 ||
          businessLicense?.toab_membership === 1) && (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload association TOAB document ( max size 5mb )'
                fieldName='toab_membership_file'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    toab_membership_file: e,
                  }))
                }
                mode='single'
                imgSerUrl={[
                  otherBusiness?.companyAssociationMembership
                    ?.toab_membership_file,
                ]}
              />
            </Box>
          </Grid>
        )}

        {/* TDAB Membership */}
        {(otherBusiness?.companyAssociationMembership?.tdab_membership === 1 ||
          businessLicense?.tdab_membership === 1) && (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload association TDAB document ( max size 5mb )'
                fieldName='tdab_membership_file'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    tdab_membership_file: e,
                  }))
                }
                mode='single'
                imgSerUrl={[
                  otherBusiness?.companyAssociationMembership
                    ?.tdab_membership_file,
                ]}
              />
            </Box>
          </Grid>
        )}
      </Grid>
      <Box sx={{ pt: 5, textAlign: 'end', mb: 2 }}>
        {isLoading ? (
          <Button
            disabled
            variant='contained'
            disableElevation
            className='add-remove-button'
          >
            Loading..
          </Button>
        ) : (
          <Button
            type='submit'
            variant='contained'
            disableElevation
            className='add-remove-button'
          >
            Save
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default CompanyBusinessLicense;
